// AUTO-GENERATED by sync-icons — do not edit.
import ArchedArrowLeftIconSvg from './ArchedArrowLeftIcon';
import ArchedArrowRightIconSvg from './ArchedArrowRightIcon';
import ArrowDownIconSvg from './ArrowDownIcon';
import ArrowLeftIconSvg from './ArrowLeftIcon';
import ArrowRightIconSvg from './ArrowRightIcon';
import ArrowUpIconSvg from './ArrowUpIcon';
import ChevronDownIconSvg from './ChevronDownIcon';
import ChevronLeftIconSvg from './ChevronLeftIcon';
import ChevronRightFatIconSvg from './ChevronRightFatIcon';
import ChevronRightIconSvg from './ChevronRightIcon';
import ChevronUpIconSvg from './ChevronUpIcon';
import OpenModalIconSvg from './OpenModalIcon';
import SortingIconSvg from './SortingIcon';
import TrendDownIconSvg from './TrendDownIcon';
import TrendUpIconSvg from './TrendUpIcon';
import { withIconWrapper } from '../../IconWrapper';
export const ArchedArrowLeftIcon = withIconWrapper(ArchedArrowLeftIconSvg);
export const ArchedArrowRightIcon = withIconWrapper(ArchedArrowRightIconSvg);
export const ArrowDownIcon = withIconWrapper(ArrowDownIconSvg);
export const ArrowLeftIcon = withIconWrapper(ArrowLeftIconSvg);
export const ArrowRightIcon = withIconWrapper(ArrowRightIconSvg);
export const ArrowUpIcon = withIconWrapper(ArrowUpIconSvg);
export const ChevronDownIcon = withIconWrapper(ChevronDownIconSvg);
export const ChevronLeftIcon = withIconWrapper(ChevronLeftIconSvg);
export const ChevronRightFatIcon = withIconWrapper(ChevronRightFatIconSvg);
export const ChevronRightIcon = withIconWrapper(ChevronRightIconSvg);
export const ChevronUpIcon = withIconWrapper(ChevronUpIconSvg);
export const OpenModalIcon = withIconWrapper(OpenModalIconSvg);
export const SortingIcon = withIconWrapper(SortingIconSvg);
export const TrendDownIcon = withIconWrapper(TrendDownIconSvg);
export const TrendUpIcon = withIconWrapper(TrendUpIconSvg);
